import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AutocompleteInput from 'components/AutocompleteInput';
import {
  BoostTitle, BoostModal, TagLabel, BoostNextButton, BoostSubtitle, BoostInputText,
  BoostUrgencyTime, BoostUrgency, Overlay,
} from './styles';

function Boost(props) {
  const [boostModalStage, setBoostModalStage] = useState('init');
  const [boostNumUser, setBoostNumUser] = useState('');
  const [boostNeeds, setBoostNeeds] = useState('');
  const [urgencySel, setUrgencySel] = useState();
  const [labels, setLabels] = useState([]);

  const handleLabel = (label) => {
    setLabels([...labels, label]);
  };

  const printTags = () => {
    return _.map(labels, (label, index) => (<TagLabel key={index}>{label.name}</TagLabel>));
  };

  const submitBoost = () => {
    const {
      saveBoost, elementType, elementId, close,
    } = props;
    const boost = {
      element_type: elementType,
      element_id: elementId,
      num_people: boostNumUser,
      boostNeeds,
      urgencySel,
      labels: labels.map(label => label.id),
    };

    boost.labels = boost.labels.join(',');
    saveBoost(boost);
    close();
  };

  const changeModalStage = (event) => {
    const { currentTarget } = event;
    const section = currentTarget.getAttribute('data-stage');
    setBoostModalStage(section);
  };

  const handleChangeNumUser = (event) => {
    setBoostNumUser(event.target.value);
  };

  const handleChangeNeeds = (event) => {
    setBoostNeeds(event.target.value);
  };

  const handleUrgency = (event) => {
    const { currentTarget } = event;
    const urg = parseInt(currentTarget.getAttribute('data-urgency'), 10);
    setUrgencySel(urg);
  };

  const boostSeed = () => {
    const { literals } = props;
    switch (boostModalStage) {
      case 'init':
        return (
          <BoostModal>
            <div className='close_button'>
              <i className='far fa-times-circle close_icon' onClick={props.close} />
            </div>
            <BoostTitle>
              {literals.boostYourThinkChatSubtitle}
            </BoostTitle>
            <BoostNextButton cont data-stage='users' onClick={changeModalStage}>
              {literals.next}
            </BoostNextButton>
          </BoostModal>
        );
      case 'users':
        return (
          <BoostModal>
            <div className='close_button'>
              <i className='far fa-times-circle close_icon' onClick={props.close} />
            </div>
            <BoostTitle>
              {literals.minimumUsersTitle}
            </BoostTitle>
            <BoostInputText type='number' value={boostNumUser} onChange={handleChangeNumUser} />
            <BoostSubtitle>
              {literals.minimumUsersSubtitle}
            </BoostSubtitle>
            <BoostNextButton cont={boostNumUser !== ''} data-stage='needs' onClick={changeModalStage}>
              {literals.next}
            </BoostNextButton>
          </BoostModal>
        );
      case 'needs':
        return (
          <BoostModal>
            <div className='close_button'>
              <i className='far fa-times-circle close_icon' onClick={props.close} />
            </div>
            <BoostTitle>
              {literals.needsTitle}
            </BoostTitle>
            <BoostInputText type='text' value={boostNeeds} onChange={handleChangeNeeds} />
            <BoostSubtitle>
              {literals.needsSubtitle}
            </BoostSubtitle>
            <BoostNextButton cont={boostNeeds !== ''} data-stage='urgency' onClick={changeModalStage}>
              {literals.next}
            </BoostNextButton>
          </BoostModal>
        );
      case 'urgency':
        return (
          <BoostModal>
            <div className='close_button'>
              <i className='far fa-times-circle close_icon' onClick={props.close} />
            </div>
            <BoostTitle>
              {literals.urgencyTitle}
            </BoostTitle>
            <BoostUrgency>
              <BoostUrgencyTime sel={urgencySel === 1} data-urgency='1' onClick={handleUrgency}>{literals.urgencyLow}</BoostUrgencyTime>
              <BoostUrgencyTime sel={urgencySel === 2} data-urgency='2' onClick={handleUrgency}>{literals.urgencyMedium}</BoostUrgencyTime>
              <BoostUrgencyTime sel={urgencySel === 3} data-urgency='3' onClick={handleUrgency}>{literals.urgencyHigh}</BoostUrgencyTime>
            </BoostUrgency>
            <BoostSubtitle>
              {literals.urgencySubtitle}
            </BoostSubtitle>
            <BoostNextButton cont={urgencySel} data-stage='label' onClick={changeModalStage}>
              {literals.next}
            </BoostNextButton>
          </BoostModal>
        );
      case 'label':
        return (
          <BoostModal>
            <div className='close_button'>
              <i className='far fa-times-circle close_icon' onClick={props.close} />
            </div>
            <BoostTitle>
              {literals.labelsTitle}
            </BoostTitle>
            <BoostUrgency>
              <AutocompleteInput
                canCreateNew
                type='tag'
                selectedOptions={labels}
                onSelectOption={handleLabel}
                onCreateOption={handleLabel}
              />
              {printTags()}
            </BoostUrgency>
            <BoostSubtitle>
              {literals.labelsSubtitle}
            </BoostSubtitle>
            <BoostNextButton cont={labels.length > 0} onClick={submitBoost}>
              {literals.finish}
            </BoostNextButton>
          </BoostModal>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Overlay />
      {boostSeed()}
    </div>
  );
}

Boost.propTypes = {
  literals: PropTypes.object.isRequired,
  elementType: PropTypes.string.isRequired,
  elementId: PropTypes.number.isRequired,
  close: PropTypes.func.isRequired,
  saveBoost: PropTypes.func.isRequired,
};

export default Boost;



// WEBPACK FOOTER //
// ./src/components/Boost/components/index.jsx